export default {"src":"/_next/static/media/stars.32d34c8e.svg","height":18,"width":98,"blurWidth":0,"blurHeight":0};